// IANA timezone list. Newer Chrome / Safari / Firefox expose
// `Intl.supportedValuesOf("timeZone")` (~400 entries), but the TS lib
// target doesn't always know about it yet; typed-narrow + fallback to
// a curated list keeps compile + runtime both happy.
const FALLBACK_ZONES: ReadonlyArray<string> = [
  "Pacific/Auckland",
  "Australia/Sydney",
  "Australia/Melbourne",
  "Australia/Brisbane",
  "Australia/Perth",
  "Asia/Tokyo",
  "Asia/Singapore",
  "Asia/Hong_Kong",
  "Asia/Bangkok",
  "Asia/Kolkata",
  "Asia/Dubai",
  "Europe/Istanbul",
  "Europe/Athens",
  "Europe/Berlin",
  "Europe/Paris",
  "Europe/London",
  "Europe/Lisbon",
  "Atlantic/Reykjavik",
  "America/Sao_Paulo",
  "America/New_York",
  "America/Toronto",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Vancouver",
  "Pacific/Honolulu",
  "UTC",
];

export const listTimezones = (): ReadonlyArray<string> => {
  const fn = (Intl as unknown as { supportedValuesOf?: (k: string) => string[] }).supportedValuesOf;
  if (typeof fn === "function") {
    try {
      return fn("timeZone");
    } catch {
      return FALLBACK_ZONES;
    }
  }
  return FALLBACK_ZONES;
};
